<template>
  <div class="container">
    <div class="title" v-if="!editId">新建客户 <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span></div>
    <div class="title" v-else>
      <span >修改客户</span> <span class="back" @click="back"> <i class="iconfont icon-fanhui"></i> 返回 </span>
    </div>

    <div class="wrap">
      <el-row>
        <el-col :lg="16" :md="20" :sm="24" :xs="24">
          <el-form :model="emailSetting" status-icon ref="form" label-width="auto" @submit.prevent :rules="rules">
            <el-form-item label="SMTP服务器地址" prop="smtp_host">
              <el-input v-model="emailSetting.smtp_host" placeholder="请填写SMTP服务器地址"></el-input>
            </el-form-item>
            <el-form-item label="SMTP服务器端口" prop="smtp_port">
              <el-input-number v-model="emailSetting.smtp_port" placeholder="请填写SMTP服务器端口"/>
            </el-form-item>
            <el-form-item label="服务器用户名" prop="smtp_username">
              <el-input v-model="emailSetting.smtp_username" placeholder="请填写服务器用户名"></el-input>
            </el-form-item>
            <el-form-item label="服务器密码" prop="smtp_password">
              <el-input v-model="emailSetting.smtp_password" placeholder="请填写服务器密码"></el-input>
            </el-form-item>
            <el-form-item label="邮件发出人" prop="smtp_from">
              <el-input v-model="emailSetting.smtp_from" placeholder="请填写邮件发出人"></el-input>
            </el-form-item>

            <el-form-item label="邮箱类型" prop="smtp_type">
                <el-select
                  v-model="emailSetting.smtp_type"
                  placeholder="邮箱类型"
                  clearable
                  filterable
                >
                  <el-option
                        v-for="item in smtpTypeArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                </el-select>

              </el-form-item>

              <el-form-item label="启用状态" prop="is_enabled">
                <el-select
                  v-model="emailSetting.is_enabled"
                  placeholder="启用状态"
                  clearable
                  filterable
                >
                  <el-option
                        v-for="item in enableArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                </el-select>

              </el-form-item>

              <el-form-item label="备注" prop="remark">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 8 }"
                  placeholder="请输入备注"
                  v-model="emailSetting.remark"
                >
                </el-input>
              </el-form-item>

          

            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm">保 存</el-button>
              <el-button @click="resetForm">重 置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { reactive, ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import sysDictItemModel from '@/model/sysDictItem'
import EmailSetting from '@/model/emailSetting'


export default {
  props: {
    editId: {
      type: String,
      default: null,
    },
  },
  setup(props, context) {
    const form = ref(null)
    const loading = ref(false)

    const smtpTypeArr=ref([])
    const enableArr=ref([])

    const emailSetting = reactive({
      id:props.editId
      ,smtp_host:''
      ,smtp_port: ''
      ,smtp_username: ''
      ,smtp_password: ''
      ,smtp_from: ''
      ,smtp_type: ''
      ,is_enabled: '1'
      ,remark:''
    })

    const listAssign = (a, b) => Object.keys(a).forEach(key => {
      a[key] = b[key] || a[key]
    })

    /**
     * 表单规则验证
     */
    const { rules } = getRules()

    onMounted(() => {
      if (props.editId) {
        getEmailSetting()
      }
      loadDictDitems()
    })
    //根据字典类型查询字典
    const loadDictDitems =async () =>{

    smtpTypeArr.value= await sysDictItemModel.getSysDictItemListByType("smtp_type")
    enableArr.value= await sysDictItemModel.getSysDictItemListByType("email_enable_flag")

    }


    const getEmailSetting = async () => {
      loading.value = true
      const res = await EmailSetting.getEmailSetting(props.editId)
      listAssign(emailSetting, res)
      emailSetting.is_enabled=String(res.is_enabled)
      loading.value = false
    }

    // 重置表单
    const resetForm = () => {
      form.value.resetFields()
    }

    const submitForm = async formName => {
      form.value.validate(async valid => {
        if (valid) {
          let res = {}
          if (props.editId) {
            res = await EmailSetting.editEmailSetting(props.editId, emailSetting)
            context.emit('editClose')
          } else {
            res = await EmailSetting.createEmailSetting(emailSetting)
            resetForm(formName)
          }
          if (res.code < window.MAX_SUCCESS_CODE) {
            ElMessage.success(`${res.message}`)
          }
        } else {
          console.error('error submit!!')
          ElMessage.error('请将信息填写完整')
        }
      })
    }

    const back = () => {
      context.emit('editClose')
    }

    return {
      back,
      emailSetting,
      form,
      rules,
      resetForm,
      submitForm,

      smtpTypeArr,
      enableArr,

    }
  },
}

/**
 * 表单验证规则
 */
function getRules() {
  /**
   * 验证回调函数
   */
  const checkInfo = (rule, value, callback) => {
    if (!value) {
      callback(new Error('信息不能为空'))
    }
    callback()
  }
  const rules = {
    smtp_host: [
      { validator: checkInfo, trigger: 'blur', required: true }
      ,{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] , required: true}
    ],
    smtp_port: [
      { validator: checkInfo, trigger: 'blur', required: true } 
    ],
    smtp_username: [
      { validator: checkInfo, trigger: 'blur', required: true }
      ,{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] , required: true}
    ],
    smtp_password: [{ validator: checkInfo, trigger: 'blur', required: true }],
    smtp_from: [
      { validator: checkInfo, trigger: 'blur', required: true }
      ,{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] , required: true}
    ],
    smtp_type: [{ validator: checkInfo, trigger: 'blur', required: true }],
    is_enabled: [{ validator: checkInfo, trigger: 'blur', required: true }],
  }
  return { rules }
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;

    .back {
      float: right;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }
}
</style>
